import { render, staticRenderFns } from "./mgrClass.vue?vue&type=template&id=6ca279de&scoped=true&"
import script from "./mgrClass.vue?vue&type=script&lang=js&"
export * from "./mgrClass.vue?vue&type=script&lang=js&"
import style0 from "./mgrClass.vue?vue&type=style&index=0&id=6ca279de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca279de",
  null
  
)

export default component.exports